export const SHOULD_TRACK = process.env.NODE_ENV !== 'development'; // Tag manager is handling if tracking is enabled or not

export const COOKIEBOT_DOMAIN_ID = process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_ID;

export const GA_TRACKING_ID_GA4 = process.env.NEXT_PUBLIC_GA_ID_GA4;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
